import { useNavigate } from "react-router";
import { bemCN } from "../../config/bem-classname";
import "./story.scss";
import { Story as StoryClass } from "../../view-models/story";
import { FC } from "react";
import { ReactComponent as BookIcon } from "../../shared/images/svg/book.svg";
import { ReactComponent as BookmarkIcon } from "../../shared/images/svg/bookmark.svg";
import { ReactComponent as VoiceIcon } from "../../shared/images/svg/voice.svg";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import { links } from "../../config/links";
import { storyService } from "../../services/story-service";
import { sendMetrics, MerticNames } from "../../utils/metrics";
import {
  localStorageService,
  LocalStorageVariableName,
} from "../../services/localStorage-service";

type StoryProps = {
  story: StoryClass;
  position: StoryPositin;
  isActive: boolean;
  onClickStory(id: number): void;
};

export enum StoryPositin {
  left,
  right,
}
const storyCn = bemCN("story");

export const Story: FC<StoryProps> = ({
  story,
  position,
  isActive,
  onClickStory,
}) => {
  const navigate = useNavigate();
  let positionClass = StoryPositin[position];

  const isAuth: boolean =
    localStorageService.getValue(LocalStorageVariableName.token) == undefined
      ? false
      : true;

  const getBookmarkStepId = () => {
    sendMetrics("reachGoal", MerticNames.bookmarkStart);
    if (isAuth) {
      storyService.getStepByBookmark(story.id).then((idStep?: number) => {
        idStep &&
          navigate(
            links.step +
              "/" +
              (idStep || story.firstStepId || -1) +
              "?isVoice=false"
          );
      });
    } else {
      navigate(links.reg);
    }
  };

  return (
    <div className={storyCn({ isActive: isActive, isBlock: !story.isBlock })}>
      <div
        onClick={() => story.isBlock && onClickStory(story.id)}
        className={storyCn("preview")}
      >
        <img src={story.imageUrl} />
        <div className={storyCn("button")}>{story.name}</div>
      </div>
      {isActive && (
        <div className={storyCn("menu", [positionClass])}>
          <div className={storyCn("menu_backgroud")}>
            <div>
              <Button
                text="С начала"
                size={ButtonSizes.big}
                icon={<BookIcon />}
                color={ButtonColors.transition}
                onClick={() => {
                  sendMetrics("reachGoal", MerticNames.startReadStoryClick);
                  navigate(
                    links.step + "/" + story.firstStepId + "?isVoice=false"
                  );
                }}
              />
              <Button
                text="Закладка"
                size={ButtonSizes.big}
                icon={<BookmarkIcon />}
                color={ButtonColors.transition}
                onClick={getBookmarkStepId}
              />
              <Button
                text="Вслух"
                size={ButtonSizes.big}
                icon={<VoiceIcon />}
                color={ButtonColors.transition}
                onClick={() => {
                  sendMetrics(
                    "reachGoal",
                    MerticNames.startReadAloudStoryClick
                  );
                  navigate(
                    links.step + "/" + story.firstStepId + "?isVoice=true"
                  );
                }}
              />
            </div>
          </div>
          <div
            onClick={() => onClickStory(-1)}
            className={storyCn("menu_transition")}
          ></div>
        </div>
      )}
    </div>
  );
};
